import { InternalMessageResponse } from "features/CenterContent/RoleContent/InternalMessage/schema/responseSchema";
import { InternalMessageEventsList } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/InternalMessageEventsList";

type InternalMessageEventsProps = {
  data: InternalMessageResponse[];
  onEditClick: (event: InternalMessageResponse) => void;
};

export const InternalMessageEvents = ({
  data,
  onEditClick,
}: InternalMessageEventsProps) => (
  <InternalMessageEventsList data={data} onEditClick={onEditClick} />
);
